import {useState} from 'react'
import {useAuth0} from '@auth0/auth0-react'

export function Login() {
  const {loginWithRedirect} = useAuth0()

  const handleLogin = () => {
    loginWithRedirect({
      appState: {screen_hint: 'login'},
    })
  }

  const handleRegistration = () => {
    loginWithRedirect({
      appState: {screen_hint: 'signup'},
    })
  }

  return (
    <div className='d-flex flex-column align-items-center'>
      <h1 className='text-dark fw-bolder mb-3'>Sign In or Register</h1>
      <br />
      <br />

      <div className='d-grid mb-10'>
        <button
          onClick={() =>
            loginWithRedirect({
              authorizationParams: {
                screen_hint: 'login',
              },
            })
          }
          className='btn btn-primary'
        >
          <span className='indicator-label'>Login</span>
        </button>
      </div>

      <div className='d-grid mb-10'>
        <button
          onClick={() =>
            loginWithRedirect({
              authorizationParams: {
                screen_hint: 'signup',
              },
            })
          }
          className='btn btn-secondary'
        >
          <span className='indicator-label'>Register</span>
        </button>
      </div>
    </div>
  )
}
